import { StyleSheet, View } from "react-native";

import { radii, useThemedStyles, type ThemeColors } from "~/styles/theme";
import { AppText } from "./AppText";

export function Avatar({
  name,
  size = "md",
}: {
  name: string;
  size?: "sm" | "md" | "lg";
}) {
  const { stylesheet, sizeStyles } = useThemedStyles(makeStyles);
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");

  return (
    <View
      accessible
      accessibilityLabel={name}
      style={[stylesheet.avatar, sizeStyles[size]]}
    >
      <AppText
        size={size === "lg" ? "base" : "xs"}
        weight="bold"
        style={stylesheet.text}
      >
        {initials || "?"}
      </AppText>
    </View>
  );
}

const makeStyles = (colors: ThemeColors) => {
  const stylesheet = StyleSheet.create({
    avatar: {
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      borderRadius: radii.pill,
      backgroundColor: colors.primary,
    },
    sm: { width: 32, height: 32 },
    md: { width: 40, height: 40 },
    lg: { width: 48, height: 48 },
    text: { color: colors.primaryForeground },
  });
  const sizeStyles = {
    sm: stylesheet.sm,
    md: stylesheet.md,
    lg: stylesheet.lg,
  };
  return { stylesheet, sizeStyles };
};
